<template><div><dt-notice kind="warning" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
Typography Styles have been moved to <a href="/design/typography/" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Design Language &gt; Typography</a>.
</dt-notice>
<p class="d-docsite--paragraph">Typography styles combine multiple typography properties – e.g. <code v-pre>font-family</code>, <code v-pre>font-size</code>, <code v-pre>line-height</code>,<code v-pre>font-weight</code> into a single class rather than combine multiple CSS Utilities.</p>
<p class="d-docsite--paragraph">For example, instead of <code v-pre>class=&quot;d-fs-200 d-lh-100&quot;</code> you would apply <code v-pre>class=&quot;d-text-body--md&quot;</code>.</p>
</div></template>


